import { Phone, Mail, MapPin } from "lucide-react";

const LOGO_URL = "https://customer-assets.emergentagent.com/job_40bbf581-5235-4696-9bdc-3ce549288854/artifacts/onxdn5ml_PBlogo.jpg";
const PHONE_NUMBER = "+15054727064";
const PHONE_DISPLAY = "(505) 472-7064";

export const Footer = () => {
  return (
    <footer className="bg-[#111827] text-white py-16" data-testid="footer">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid md:grid-cols-3 gap-12">
          {/* Logo & About */}
          <div>
            <img 
              src={LOGO_URL} 
              alt="Prime Baths of NM" 
              className="h-12 w-auto mb-6"
            />
            <p className="text-gray-400 leading-relaxed">
              New Mexico's trusted bathroom remodeling experts. Transform your space with our premium services and exceptional craftsmanship.
            </p>
          </div>

          {/* Services */}
          <div>
            <h4 className="text-lg font-bold mb-6 font-['Playfair_Display']">Our Services</h4>
            <ul className="space-y-3">
              <li>
                <a href="/bathroom-remodeling" className="text-gray-400 hover:text-white transition-colors duration-200">
                  Bathroom Remodeling
                </a>
              </li>
              <li>
                <a href="/tub-shower-conversions" className="text-gray-400 hover:text-white transition-colors duration-200">
                  Tub & Shower Conversions
                </a>
              </li>
              <li>
                <a href="/walk-in-tubs" className="text-gray-400 hover:text-white transition-colors duration-200">
                  Walk-In Tubs
                </a>
              </li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="text-lg font-bold mb-6 font-['Playfair_Display']">Contact Us</h4>
            <ul className="space-y-4">
              <li className="flex items-center gap-3">
                <Phone className="h-5 w-5 text-[#1E4C9A]" />
                <a href={`tel:${PHONE_NUMBER}`} className="text-gray-400 hover:text-white transition-colors duration-200">
                  {PHONE_DISPLAY}
                </a>
              </li>
              <li className="flex items-center gap-3">
                <Mail className="h-5 w-5 text-[#1E4C9A]" />
                <a href="mailto:primebathofnm@gmail.com" className="text-gray-400 hover:text-white transition-colors duration-200">
                  primebathofnm@gmail.com
                </a>
              </li>
              <li className="flex items-start gap-3">
                <MapPin className="h-5 w-5 text-[#1E4C9A] mt-1" />
                <span className="text-gray-400">
                  Serving Albuquerque & All of New Mexico
                </span>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-gray-800 mt-12 pt-8 text-center">
          <p className="text-gray-500 text-sm">
            © {new Date().getFullYear()} Prime Baths of New Mexico. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};
